import "../scss/faq.scss";
import { categoryAccordion } from '../components/faq';
import { Accordion } from '../components/accordion';

categoryAccordion();
new Accordion('.accordion-spec');